export const WIN = 'Win';
export const LOSE = 'Lose';
export const ALL_BETS = 'All Bets';
